import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IModalState, showModal } from "store/reducers/modal";
import { Button, Modal } from "antd";
import { sendTickerCommand } from "store/reducers/TabsSlice";
import { useNavigate } from "react-router-dom";

const ErrorFullModal = () => {
    const { modals, args } = useSelector(
        (state: { modals: IModalState }) => state.modals,
    );
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleNavigate = () => {
        handleClose();
        navigate("/settings");
    };
    const handleReload = async () => {
        try {
            await dispatch(
                sendTickerCommand({
                    command: "RT",
                }),
            );
            handleClose();
            console.log("Команда RRO успешно отправлена");
        } catch (error) {
            console.error("Ошибка при отправке команды RRO:", error);
        }
    };
    const handleClose = () => {
        dispatch(
            showModal({
                modal_type: "ui_block_full",
                value: false,
            }),
        );
    };
    if (modals.ui_block_full) {
        return (
            <Modal
                open={false}
                mask={true}
                maskStyle={{
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    zIndex: 1000,
                    opacity: 0.33,
                }}
                footer={null}
                onCancel={handleClose}
                // closable={false} // Нельзя закрыть
                // maskClosable={false} // Нельзя закрыть кликом на маску
                // keyboard={false} // Нельзя закрыть через Esc
                centered
                className="error-full-modal"
                width="70%"
                zIndex={1000}
                style={{ top: 0, height: "80vh", zIndex: 1001 }}
                bodyStyle={{
                    height: "80vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderTopLeftRadius: "20px",
                    borderTopRightRadius: "20px",
                    boxShadow: "4px 0px 8px 0px rgba(255, 0, 0, 0.2)",
                }}
                getContainer={() => document.body}
            >
                <div
                    style={{
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                    }}
                >
                    <h2 style={{ color: "red", fontWeight: 700 }}>UI Block</h2>
                    <p>{args?.message || "Произошла ошибка"}</p>
                    {args?.event_type && <p>Тип события: {args.event_type}</p>}
                    <div
                        style={{
                            marginTop: "auto",
                            display: "flex",
                            gap: "12px",
                        }}
                    >
                        <Button key="close" onClick={handleClose}>
                            Закрыть
                        </Button>

                        {/* <Button
                            key="reload"
                            type="primary"
                            onClick={handleReload}
                        >
                            Перезагрузка
                        </Button> */}
                        <Button
                            key="reload"
                            type="primary"
                            onClick={handleNavigate}
                        >
                            Перейти в настройки
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    }
    return null;
};

export default ErrorFullModal;
